export default __webpack_public_path__ + "static/media/Washingtonplatz_Schilder.864edb2c.jpg";